<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="applyCouponModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="exampleModalLongTitle">
            كوبون Academia
          </h5>
        </div>
        <div class="modal-body">
          <div class="support-box">
            <img
              class="support-img text-center"
              src="assets/images/coupon.png"
              alt=""
            />
          </div>
          <h4 class="mb-2 text-center support-text">أدخل أدناه رمز الكوبون</h4>
          <form class="form-horizontal" action="home.html">
            <div style="min-height: 10px">
              <span
                id="error-message"
                style="color: red; display: none; text-align: right"
              >
                يرجى تحديد رقم الهاتف يرجى تحديد رقم الهاتف يرجى تحديد رقم
                الهاتف يرجى تحديد رقم الهاتف
              </span>
              <div
                id="cert-btn"
                style="text-align: center; display: none"
              ></div>
            </div>

            <div class="row" dir="rtl">
              <div class="col-md-12">
                <div class="form-group form-group-custom mb-4" dir="rtl">
                  <label for="name">رمز الكوبون </label>
                  <input
                    type="text"
                    class="form-control"
                    id="code"
                    placeholder="XXXXXXXXX"
                    v-model="code"
                  />
                </div>

                <div class="mt-4">
                  <button
                    style="width: 100%"
                    ref="applyCouponBtn"
                    id="applyCouponBtn"
                    @click="applyCoupon"
                    class="p-3 btn btn-success btn-block waves-effect waves-light"
                    type="button"
                  >
                    تطبيق <i class="fa fa-check-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            تراجع
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { applyCoupon, removeCoupon } from "@/utils/cart";

export default {
  name: "Academia",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      isLoading: false,
    };
  },
  mounted() {},
  methods: {
    applyCoupon() {
      const couponCode = this.code.trim(); // Trim to remove any leading/trailing spaces
      const button = this.$refs.applyCouponBtn;
      const token = this.token;

      if (!couponCode) {
        // Show an error message if the coupon code is empty
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "يرجى إدخال رمز الكوبون",
          confirmButtonText: "حسناً",
        });
        return;
      }

      // Proceed with applying the coupon
      applyCoupon(couponCode, $(button));
    },
    removeCoupon() {
      removeCoupon();
    },
  },
};
</script>

<style scoped>
.icon-img {
  margin-bottom: 10px;
  width: 100px;
}

#academia-code {
  text-align: center;
  border: 0px;
  background: #ededed;
  height: unset;
}

.btn-charge {
  padding: 10px 50px;
  font-weight: 600;
  background: rgb(0, 196, 68);
}
</style>
